// extracted by mini-css-extract-plugin
module.exports = {"label":"CheckboxField_label__QMshJ"};